<template>
  <section>
    <div class="player text-md-center">
        <svg class="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" v-if="descargando">
           <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
        </svg>
        <!-- Si existe imagen preview -->
        <imagen-viewer :caso="caso" :msg_id="msg_id" :extras="extras" :file="file" :mime="mime" :controls="false" v-if="esImagen" @clicked="reproducir"></imagen-viewer>
        <!-- Si no existe imagen preview -->
        <img v-if="sinPreview" src="@/assets/images/no-preview.png" height="150px" v-on:click.prevent="reproducir">
        <video style="display: none;margin: 0 auto;" :loop="innerLoop" :src="blob" height="150px" width="350px" @click="reproducir"></video>
        <div class="player-controls">
          <div>
            <a v-on:click.prevent="reproducir" title="Reproducir/Pausar" href="#">
              <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path v-if="!playing" fill="currentColor" d="M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852c0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"/>
                <path v-else fill="currentColor" d="M15,3h-2c-0.553,0-1,0.048-1,0.6v12.8c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5C4.447,3,4,3.048,4,3.6v12.8C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"/>
              </svg>
            </a>
          </div>
          <div>
            <div v-on:click="seek" class="player-progress" title="Tiempo reproducido : Tiempo Total">
              <div :style="{ width: this.percentComplete + '%' }" class="player-seeker"></div>
            </div>
            <div class="player-time">
              <div class="player-time-current">{{ currentTime }}</div>
              <div class="player-time-total">{{ durationTime }}</div>
            </div>
          </div>
          <div>
            <a v-on:click.prevent="mute" title="Silenciar" href="#" v-if="this.muteButton">
              <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path v-if="!muted" fill="currentColor" d="M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789c1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928C6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156zM15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0L14.02,4.568c-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388l1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388L10.736,2.44C10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061c-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z"/>
                <path v-else fill="currentColor" d="M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527c4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941c-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384C5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108c-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0l15.629-15.63C18.912,2.501,18.912,1.868,18.521,1.478z"/>
              </svg>
            </a>
          </div>
          <div>
            <a v-on:click.prevent="fullscreen" title="Ver en pantalla completa" href="#" v-if="this.fullscreenButton">
              <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path fill="currentColor" d="M10 5h-3l5-5 5 5h-3v3h-4v-3zm4 14h3l-5 5-5-5h3v-3h4v3zm-9-5v3l-5-5 5-5v3h3v4h-3zm14-4v-3l5 5-5 5v-3h-3v-4h3z"/>
              </svg>
            </a>
          </div>
          <div>
            <a v-on:click.prevent="download" title="Descargar" href="#" v-if="this.downloadButton">
              <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path fill="currentColor" d="M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757l3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408L5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449l0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074C20.096,14.468,19.828,14.053,19.338,13.532z"/>
              </svg>
            </a>
          </div>
          <div v-if="false">
            <a v-on:click.self.prevent v-on:mouseenter="showVolume = true" title="Volume" href="#">
              <svg width="18px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path fill="currentColor" d="M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9V13.805z"/>
              </svg>
              <input v-model.lazy.number="volume" v-show="showVolume" type="range" min="0" max="100"/>
            </a>
          </div>
        </div>
    </div>
  </section>
</template>
<script>
import ImagenViewer from '@/common/plugins/imagen/Imagen';
import axios from 'axios';
const convertTimeHHMMSS = (val) => {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);

  return hhmmss.indexOf('00:') === 0 ? hhmmss.substr(3) : hhmmss;
};
export default {
  props: {
    msg_id: {
      type: String,
      default: null
    },
    caso: {
      type: Number,
      default: null
    },
    file: {
      type: String,
      default: null
    },
    mime: {
      type: String,
      default: null
    },
    muteButton: {
      type: Boolean,
      default: false
    },
    downloadButton: {
      type: Boolean,
      default: false
    },
    fullscreenButton: {
      type: Boolean,
      default: false
    },
    extras: {
      type: Object,
      default: function () { return {}; }
    }
  },
  created () {
    this.innerLoop = this.loop;
  },
  beforeDestroy () {},
  mounted () {
    this.video = this.$el.querySelectorAll('video')[0];
    this.video.addEventListener('timeupdate', this.update);
    this.video.addEventListener('loadeddata', this.load);
    this.video.addEventListener('pause', () => { this.playing = false; });
    this.video.addEventListener('play', () => { this.playing = true; });

    this.downloadFile(this.file, this.mime);
  },
  data () {
    return {
      descargando: false,
      blob: null,
      original: null,
      video: undefined,
      currentSeconds: 0,
      durationSeconds: 0,
      innerLoop: false,
      loaded: false,
      playing: false,
      previousVolume: 35,
      showVolume: false,
      volume: 100
    };
  },
  computed: {
    currentTime () {
      return convertTimeHHMMSS(this.currentSeconds);
    },
    durationTime () {
      return convertTimeHHMMSS(this.durationSeconds);
    },
    percentComplete () {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    },
    muted () {
      return this.volume / 100 === 0;
    },
    esImagen () {
      return (this.mime.indexOf('image') !== -1) && (!this.original && !this.descargando);
    },
    sinPreview () {
      return (this.mime.indexOf('image') === -1) && (!this.original && !this.descargando);
    }
  },
  watch: {
    blob () {},
    original () {
      if (this.original) {
        this.video.style.display = 'block';
      }
    },
    playing (value) {
      if (value) { return this.video.play(); }
      this.video.pause();
    },
    volume (value) {
      this.showVolume = false;
      this.video.volume = this.volume / 100;
    }
  },
  methods: {
    async reproducir () {
      if (!this.blob && this.file && this.file !== '') {
        await this.downloadFile(this.file, this.mime);
      }
      if (!this.original && this.msg_id && this.caso) {
        await this.downloadOriginal();
      } else {
        this.original = this.blob;
      }

      this.playing = !this.playing;
    },
    async downloadFile (url, type) {
      if (url.indexOf('data:') === -1) {
        let _urlTarget = `${url}`;
        if (url.indexOf('http') === -1) {
          _urlTarget = `${process.env.API_URL}${url}`;
        }
        try {
          return new Promise((resolve, reject) => {
            axios({
              url: _urlTarget,
              method: 'GET',
              responseType: 'arraybuffer',
              headers: {
                Authorization: `${this.$authToken} ${this.$storage.get('token')}`
              }
            }).then(response => {
              let file = new window.Blob([response.data], { type: type });
              this.blob = window.URL.createObjectURL(file);
            })
            .catch(err => {
              // this.$message.error(err.message);
              console.log(err.message);
              this.blob = this.file;
            });
          });
        } catch (err) {
          // this.$message.error(err.message);
          this.blob = this.file;
        }
      } else {
        this.blob = this.file;
      }
    },
    async downloadOriginal () {
      this.$loading.show('Preparando video...');
      try {
        this.descargando = true;
        let url = `system/mensajes/descargar/${this.caso}/${this.msg_id}`;
        return new Promise((resolve, reject) => {
          axios({
            url: `${process.env.API_URL}${url}`,
            method: 'GET',
            responseType: 'arraybuffer',
            headers: {
              Authorization: `${this.$authToken} ${this.$storage.get('token')}`
            }
          }).then(response => {
            this.$loading.hide();
            this.descargando = false;
            this.loading = false;
            let _options = {};
            if (response.headers && response.headers.hasOwnProperty(`content-type`)) {
              _options.type = response.headers['content-type'];
            }
            let file = new window.Blob([response.data], _options);
            this.blob = window.URL.createObjectURL(file);
            this.original = this.blob;
            // this.$message.success(`El archivo original esta preparado para su Descarga!`, null, { timeout: 2000 });
          })
          .catch(err => {
            this.$loading.hide();
            this.descargando = false;
            // this.$message.error(err.message);
            this.original = this.blob;
            console.log(err.message);
            // this.$message.success(`El archivo original esta preparado para su Descarga!`, null, { timeout: 2000 });
          });
        });
      } catch (err) {
        this.$loading.hide();
        this.descargando = false;
        this.original = this.blob;
        this.$message.error(err.message);
        // this.$message.success(`El archivo original esta preparado para su Descarga!`, null, { timeout: 2000 });
      }
    },
    async download () {
      this.stop();
      if (!this.blob && this.file && this.file !== '') {
        await this.downloadFile(this.file, this.mime);
      }
      if (!this.original && this.msg_id && this.caso) {
        await this.downloadOriginal();
      } else {
        this.original = this.blob;
      }

      const link = document.createElement('a');
      link.href = this.blob;
      link.setAttribute('target', '_blank');
      link.setAttribute('download', `Archivo`);
      document.body.appendChild(link);
      link.click();
    },
    load () {
      if (this.video.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.video.duration);
        this.playing = this.autoPlay;
        return;
      }

      throw new Error('Failed to load sound file.');
    },
    mute () {
      if (this.muted) {
        this.volume = this.previousVolume;
        return;
      }
      this.previousVolume = this.volume;
      this.volume = 0;
    },
    seek (e) {
      if (!this.playing || e.target.tagName === 'SPAN') {
        return;
      }
      const el = e.target.getBoundingClientRect();
      const seekPos = (e.clientX - el.left) / el.width;

      this.video.currentTime = parseInt(this.video.duration * seekPos);
    },
    fullscreen () {
      if (this.video.requestFullscreen) {
        this.video.requestFullscreen();
      } else if (this.video.mozRequestFullScreen) {
        this.video.mozRequestFullScreen();
      } else if (this.video.webkitRequestFullscreen) {
        this.video.webkitRequestFullscreen();
      } else if (this.video.msRequestFullscreen) {
        this.video.msRequestFullscreen();
      }
    },
    stop () {
      this.playing = false;
      this.video.currentTime = 0;
    },
    update (e) {
      this.currentSeconds = parseInt(this.video.currentTime);
    }
  },
  updated () {},
  components: { axios, ImagenViewer }
};
</script>
<style src="./video.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/common/plugins/video/Video.vue